/**
 * Reads a preview from a link or QR code (`/preview/<id>?songIds=...`): it contains only the id of the playlist and
 * the song ids of its items, no title and no notes.
 */
export class PlaylistPreviewParser {
  public static readonly PARAM_KEY_NAME = "songIds";

  public songIdsFromUrl(url: string): string[] | undefined {
    const songIds =
      this.getUrlParams(url)[PlaylistPreviewParser.PARAM_KEY_NAME];
    const ids = (songIds ?? "").split(",").filter((v) => v !== "" && v !== "0");
    if (ids.length === 0) {
      console.debug("PlaylistPreviewParser: no song ids in the url", {
        url,
        songIdsParam: songIds,
      });
      return undefined;
    }
    return ids;
  }

  private getUrlParams(url: string): { [p: string]: string } {
    const hashes = url.slice(url.indexOf("?") + 1).split("&");
    return hashes.reduce((params, hash) => {
      const [key, val] = hash.split("=");
      return Object.assign(params, { [key]: decodeURIComponent(val) });
    }, {});
  }
}
